import React from "react";

export default function LoadingComponent({ className }) {
	return (
		<div className="flex items-center justify-center">
			<div
				className={`animate-spin rounded-full h-8 w-8 border-t-4 border-yellow-400 ${className}`}
			></div>
		</div>
	);
}
